module.exports = __webpack_public_path__ + "img/img_vip@2x.8384fd26.png";